import React, { FC, Fragment, ReactNode } from 'react';

import {
  BreadcrumbCurrent,
  BreadcrumbLink,
  BreadcrumbNav,
  BreadcrumbSeparator,
} from './styled';

export type BreadcrumbItem = {
  label: ReactNode;
  /** When omitted, the item is rendered as the (non-link) current page label. */
  to?: string;
};

export type BreadcrumbProps = {
  items: BreadcrumbItem[];
  separator?: ReactNode;
  ariaLabel?: string;
  className?: string;
};

const Breadcrumb: FC<BreadcrumbProps> = ({
  items,
  separator = '\u203A',
  ariaLabel = 'Breadcrumb',
  className,
}) => {
  if (items.length === 0) return null;

  return (
    <BreadcrumbNav aria-label={ariaLabel} className={className}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const key = `breadcrumb-${index}`;
        const node = item.to ? (
          <BreadcrumbLink to={item.to}>{item.label}</BreadcrumbLink>
        ) : (
          <BreadcrumbCurrent>{item.label}</BreadcrumbCurrent>
        );
        return (
          <Fragment key={key}>
            {node}
            {!isLast ? (
              <BreadcrumbSeparator aria-hidden>{separator}</BreadcrumbSeparator>
            ) : null}
          </Fragment>
        );
      })}
    </BreadcrumbNav>
  );
};

export default Breadcrumb;
